function resolveBundleChart (bundleResponse, chartId, role) {
  const charts = Array.isArray(bundleResponse && bundleResponse.charts) ? bundleResponse.charts : []
  return charts.find(chart => chart && chart.chartId === chartId) ||
    charts.find(chart => chart && chart.role === role) ||
    null
}

module.exports = {
  resolveBundleChart
}
